export const MOBILE = (typeof window !== 'undefined') ? (window.screen.availWidth < 800) : true;
//export const API_BAScE_URL: string = `http://${HOST}:${PORT}`;
//export const DEFAULT_SUBDOMAIN:string = "rastaclinic";




// export const API_BASE_URL: string = `/admin/`;
// export const API_BASE_URL: string = `https://reserweb.ir/admin/`;
// export const API_BASE_URL: string = `https://app.planovin.com/admin/`;
export const API_BASE_URL: string = process.env.API_BASE_URL;
// export const API_BASE_URL: string = 'http://localhost:8080/';
// export const API_BASE_URL: string = 'https://ssaa.planovin.com/admin/';

// export const DEFAULT_SUBDOMAIN: string = "http://ssaa.planovin.com";
// export const DEFAULT_SUBDOMAIN: string = "http://mashhadtrip.planovin.com";
export const DEFAULT_SUBDOMAIN: string = "http://consult.planovin.com";
// export const DEFAULT_SUBDOMAIN: string = "http://nailbyhoda.planovin.com";
// export const DEFAULT_SUBDOMAIN: string = "http://space.planovin.com";
// export const DEFAULT_SUBDOMAIN: string = "http://dayacare.planovin.com";
// export const DEFAULT_SUBDOMAIN: string = "http://ghdbcbvx.planovin.com";
// export const DEFAULT_SUBDOMAIN: string = "http://miniature.planovin.com";


// export const API_BASE_URL: string = 'https://ssaa.planovin.com/admin';


// export const API_BASE_URL: string = `https://appviser.ir/admin`;
// export const DEFAULT_SUBDOMAIN:string="http://dkomail.reserweb.ir";const
// export const DEFAULT_SUBDOMAIN:string="http://tida.reserweb.ir";
// export const DEFAULT_SUBDOMAIN:string="https://tamin-baharestan.reserweb.ir/";
// export const DEFAULT_SUBDOMAIN:string="https://agent3001.reserweb.ir/";

// export const DEFAULT_SUBDOMAIN: string = "http://superstar.appviser.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://drsanjari.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://atelieh.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://ateliehtest.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://foxescapeclub.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://atiland.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://consult.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://space.planovin.com";



//export const DEFAULT_SUBDOMAIN: string = "http://reserweb.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://nikrah.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "http://beauty1.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "https://varamin.reserweb.ir";
// export const DEFAULT_SUBDOMAIN: string = "https://fazakari.reserweb.ir";
//   export const DEFAULT_SUBDOMAIN: string = "http://xbody-tehranpars.reserweb.ir";
//export const DEFAULT_SUBDOMAIN: string = "http://appviser.reserweb.ir";
export const DEFAULT_VIDEO_CALL_URL: string = "https://meet.jit.si/RWB-";

export const APP_VERSION: string = "2020-05-14"; // after each changes must set


export const API_URL_LOGIN: string = API_BASE_URL + 'api/authenticate';
export const API_URL_LOGEDINUSER: string = API_BASE_URL + 'api/authenticate';
export const API_URL_ACCOUNT: string = API_BASE_URL + 'api/account';
export const API_URL_REGISTER: string = API_BASE_URL + 'api/client/client-register';
export const API_URL_RESET_PASSWORD: string = API_BASE_URL + 'api/client/account/reset_password_by_phone_number';
export const API_URL_ACTIVATE_ACCOUNT: string = API_BASE_URL + 'api/activate';
export const API_URL_REGEN_ACTIVATE_CODE: string = API_BASE_URL + 'api/activate/regenerate_key';
export const API_URL_SEND_ACTIVATION_CODE: string = API_BASE_URL + 'api/activate/sendActivationCode';
export const API_URL_SEND_ACTIVATION_CODE_TO_RESET_PASSWORD: string = API_BASE_URL + 'api/client/resetPassword/sendActivationCodeClient';
export const API_URL_CONFIRM_ACTIVATION_CODE: string = API_BASE_URL + 'api/activate/confirmActivationCode';
export const API_URL_LOGOUT: string = API_BASE_URL + 'api/logout';
export const API_URL_COMPANY_BY_KEY_URL: string = API_BASE_URL + 'api/client/get-company-info-by-key-url';
export const API_URL_ROOT_CATEGORIES_BY_KEY_URL: string = API_BASE_URL + 'api/client/get-root-categories-by-key-url';
export const API_URL_COMPANY_BY_DOMAIN: string = API_BASE_URL + 'api/client/get-company-info-by-domain';
export const API_URL_CATEGORIES_BY_PARENT_ID: string = API_BASE_URL + 'api/client/get-categories-by-parent';
export const API_URL_SERVICES_BY_CATEGORY_ID: string = API_BASE_URL + 'api/client/get-service-item-by-category';
export const API_URL_SERVICES_HEADER_BY_CATEGORY_ID: string = API_BASE_URL + 'api/client/get-service-items-header-by-category';
export const API_URL_PROMOTED_SERVICES_BY_COMPANY_ID: string = API_BASE_URL + 'api/client/get-promoted-service-item-by-company';
export const API_URL_SERVICE_DETAIL_BY_SERVICE_ID: string = API_BASE_URL + 'api/client/get-service-item-by-id';
export const API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDTIMESESSION: string = API_BASE_URL + 'api/client/price-info-dtails-by-service-item-from-time-session';
export const API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDSTARTDATE: string = API_BASE_URL + 'api/client/price-info-dtails-by-service-item-and-date';
export const API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_SERVANTID_ANDSTARTDATE: string = API_BASE_URL + 'api/client/price-info-dtails-by-service-item-and-servant-and-date';
export const API_URL_SERVICE_SESSION_DATES_BY_SERVICE_ID: string = API_BASE_URL + 'api/client/get-service-time-session-from-to-date';
export const API_URL_SERVICE_SESSION_TIMES_BY_SERVICE_ID: string = API_BASE_URL + 'api/client/get-service-time-session-times-in-one-date';
export const API_URL_SERVICE_SESSION_DATES_BY_SERVICE_ID_AND_SERVANT_ID: string = API_BASE_URL + 'api/client/get-available-dates-by-service-servant';
export const API_URL_SERVICE_SESSION_TIMES_BY_SERVICE_ID_AND_SERVANT_ID: string = API_BASE_URL + 'api/client/get-available-times-by-service-servant-in-one-date';
export const API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID: string = API_BASE_URL + 'api/client/price-info-dtails-by-service-item';
export const API_URL_SERVICE_OPTIONS_BY_SERVICE_ID: string = API_BASE_URL + 'api/client/service-option-items-by-service-item';
export const API_URL_SERVICE_TIME_SESSION_BY_ID: string = API_BASE_URL + 'api/client/get-service-time-session-by-id';
export const API_URL_IMAGE_BY_IMAGE_ID: string = API_BASE_URL + 'api/client/get-image-data-by-id';
export const API_URL_IMAGE_THUMB_BY_IMAGE_ID: string = API_BASE_URL + 'api/client/get-image-thumb-data-by-id';
export const API_URL_CONFIRM_ORDER_BAG: string = API_BASE_URL + 'api/client/order-bags';
export const API_URL_SAVE_CLIENT_RESERVE: string = API_BASE_URL + 'api/client/save-client-reserve';
export const API_URL_APPVISER_SAVE_CLIENT_RESERVE: string = API_BASE_URL + 'api/client/save-client-appviser-reserve';
export const API_URL_PAY_ORDER_BAG: string = API_BASE_URL + 'api/client/pay-order-bags';
export const API_URL_COMPUTE_ORDER_BAG_PRICE: string = API_BASE_URL + 'api/client/compute-orderbag-final-price';
export const API_URL_CONFIRM_ORDER_BAG_PAYMENT: string = API_BASE_URL + 'api/client/final-approve-order-bag-by-authority';
export const API_URL_FINAL_CONFIRM_ORDER_BAG: string = API_BASE_URL + 'api/client/final-approve-order-bag-by-id';
export const API_URL_DELETE_ORDER_BAG_BY_AUTHURITY: string = API_BASE_URL + 'api/client/delete-order-bag-by-authority';
export const API_URL_GET_ORDER_BAG_BY_AUTHORITY: string = API_BASE_URL + 'api/client/order-bag-by-authority';
export const API_URL_CANCEL_RESERVE: string = API_BASE_URL + 'api/client-cancel-reserve';
export const API_URL_GET_ORDER_BAG_BY_ID: string = API_BASE_URL + 'api/client/order-bag-by-id';
export const API_URL_GET_VIDEO_MEETING_LINK_BY_ORDER_BAG_ITEM_ID: string = API_BASE_URL + 'api/client/get-video-link-by-order-bag-item-id';


export const API_URL_AUTO_SELECT_SERVANT_BY_SERVICE_ID: string = API_BASE_URL + 'api/client/auto-select-servant';
export const API_URL_GET_ORDER_BAG_DETAIL_BY_ID: string = API_BASE_URL + 'api/client/get-order-bag-by-id';
export const API_URL_GET_ORDER_BAG_LIST: string = API_BASE_URL + 'api/client/get-active-order-bag-by-current-user';
export const API_URL_GET_IAMAGELIST_BY_ALBUM_ID: string = API_BASE_URL + 'api/client/image-data-vm-by-albumid';

export const PAYMENT_WEB_URL: string = 'https://www.zarinpal.com/pg/StartPay/';

export const API_URL_GET_USER_CAN_PAY_INPLACE: string = API_BASE_URL + 'api/client/user-can-pay-in-place';
export const API_URL_SERACH_COMPANY: string = API_BASE_URL + 'api/client/_search/companies';
export const API_URL_GET_COMPANY_LIST_BY_PARENT_ID: string = API_BASE_URL + 'api/client/get-company-list-by-parent-id';
export const API_URL_SERACH_SERVICE_ITEM: string = API_BASE_URL + 'api/client/_search/service-items';
export const API_URL_COMPANY_WORKING_TIME_BY_ID: string = API_BASE_URL + 'api/client/working-time-by-company/';
export const API_URL_COMPANY_SOCIAL_NETWOR_BY_ID: string = API_BASE_URL + 'api/client/social-network-infos-by-company/';
export const API_URL_GET_AVAILABLE_CAPACITY_FOR_TIMESPAN: string = API_BASE_URL + 'api/client/get-available-capacity-for-timespan';
export const API_URL_GET_SELECTOR_DATA_BY_TYPE_ID: string = API_BASE_URL + 'api/client/selector-data-by-typeid';
export const API_URL_FILE_UPLOAD: string = API_BASE_URL + 'api/client/clientuploadFile';
export const API_URL_GET_COMPANY_LIST_BY_MARKET_PLACE_COMPANY_ID: string = API_BASE_URL + 'api/client/get-company-list-by-marketplace-company-id';
export const API_URL_GET_MARKET_PLACE_COMPANY_CARD_IMAGE_BY_ALBUM_ID: string = API_BASE_URL + 'api/client/market-place-company-card-image-data-vm-by-albumid';
export const API_URL_GET_MARKET_PLACE_BY_KEY_URL: string = API_BASE_URL + 'api/client/get-market-place-by-key-url';


export const API_URL_GET_SERVANT_BY_COMPANY_ID: string = API_BASE_URL + 'api/client/servants-by-company';
export const API_URL_GET_SERVICE_BY_SERVANT_ID: string = API_BASE_URL + 'api/client/get-published-service-item-by-servant';
export const API_URL_GET_SERVANT_BY_ID: string = API_BASE_URL + 'api/client/get-servant-by-id';
export const API_URL_GET_USER_INFO_BY_ID: string = API_BASE_URL + 'api/client/company-customers';
export const API_URL_GET_COMPANY_CUSTOM_FORM_BY_ID: string = API_BASE_URL + 'api/client/get-company-custom-form-by-company-id';
export const API_URL_SAVE_COMPANY_CUSTOM_FORM_DATA: string = API_BASE_URL + 'api/client/company-customer-form-data';
export const API_URL_DELETE_COMPANY_CUSTOM_FORM_DATA_BY_ID: string = API_BASE_URL + 'api/client/company-customer-form-data';
export const API_URL_GET_COMPANY_CUSTOMER_FORM_DATA_BY_COMPANY_CUSTOM_FORM_ID: string = API_BASE_URL + 'api/client/get-new-company-customer-form-data-by-company-custom-form-id';
export const API_URL_GET_COMPANY_CUSTOM_FORM_DATA_BY_COMPANY_CUSTOMER_ID: string = API_BASE_URL + 'api/client/get-company-custom-form-data-by-company-customer-id';
export const API_URL_SAVE_COMPANY_CUSTOMER: string = API_BASE_URL + 'api/client/update-company-customer';
export const API_URL_GET_COMPANY_CUSTOMER_BY_USER_ID_AND_COMPANY_ID: string = API_BASE_URL + 'api/client/company-customers-by-user-id-and-company-id';
export const API_URL_GET_COMPANY_EMPTY_CUSTOMER_INTAKE_DATA_BY_ID: string = API_BASE_URL + 'api/client/get-empty-company-customer-intake-data-by-company-id';
export const API_URL_GET_COMPANY_CUSTOMER_INTAKE_DATA_BY_ID: string = API_BASE_URL + 'api/client/get-company-customer-intake-data-by-company-id';
export const API_URL_GET_COMPANY_CUSTOMER_FOR_DATA_ENTRY_BY_COMPANY_ID: string = API_BASE_URL + 'api/client/get-company-customer-for-data-entry-by-company-id';

export const DEFAULT_IMAGE_DIRECTORY: string = 'assets/img/default-images';

export const BASE_WEDOMEET_API_URL: string = 'http://meet.wdmeet.ir/bigbluebutton/api';
export const WEDOMEET_SECRET_KEY: string = 'KwHLpDKtYOGBQnJZOAgZLWI7EoTaUMa3jsE9ydd8U';

export const CREATE_VIDEO_MEETING_API_URL: string = API_BASE_URL + 'api/client/create-video-meeting';
export const JOIN_VIDEO_MEETING_API_URL: string = API_BASE_URL + 'api/client/join-video-meeting';
export const IS_VIDEO_MEETING_RUNNING_API_URL: string = API_BASE_URL + 'api/client/is-meeting-running';
export const GET_MEETING_URL_API_URL: string = API_BASE_URL + 'api/client/get-meeting-url';


export const API_URL_EVALUATE_COUPON: string = API_BASE_URL + 'api/client/evaluate-coupon';
export const API_URL_LOG_INTO_SERVER: string = API_BASE_URL + 'api/client/log-from-client';

export const API_URL_SEND_ACTIVATION_CODE_BY_COMPANY: string = API_BASE_URL + 'api/activate/sendActivationCodeByCompany';
export const API_URL_SEND_ACTIVATION_CODE_TO_RESET_PASSWORD_BY_COMPANY: string = API_BASE_URL + 'api/client/resetPassword/sendActivationCodeClientByCompany';

export const API_URL_VERIFY_NATIONAL_CODE_BY_SABT_AHVAL: string = API_BASE_URL + 'api/client/verify-national-code-by-sabt-ahval';
export const API_URL_REGISTER_WITH_PERSON_INFO: string = API_BASE_URL + 'api/client/client-register-with-person-info';

export const API_URL_GET_COMPANY_OPEN_HOURS_TO_RESERVE: string = API_BASE_URL + 'api/client/get-company-open-hours-to-reserve';

export const API_URL_SAVE_REMOVE_ORDER_BAG_SERVICE_ITEM_BY_ID: string = API_BASE_URL + 'api/client/remove-order-bag-service-item';

export const API_URL_GET_VIDEO_CALL_SETTING_BY_ORDER_BAG_ITEM_ID: string = API_BASE_URL + 'api/client/get-video-call-setting-by-order-bag-item-id';

export const API_URL_GET_ALL_AVAILABLE_TIMES_BY_SERVICE_SERVANT: string = API_BASE_URL + 'api/client/get-all-available-times-by-service-servant';


export const API_URL_INVOICE_INFO_DETAIL_BY_ID: string = API_BASE_URL + 'api/client/get-invoice-info-detail-by-id';

//Test API
export const API_URL_TEST_MAKE_ONLINE_PAYMENT_AP: string = API_BASE_URL + 'api/client/makeTestPaymentAP';
export const API_URL_TEST_VERIFY_ONLINE_PAYMENT_AP: string = API_BASE_URL + 'api/client/verifyTestPaymentAP';
export const API_URL_TEST_GET_TRANS_DETAIL_AP: string = API_BASE_URL + 'api/client/getTestTransDetailAP';

//Test SEP
export const API_URL_TEST_MAKE_ONLINE_PAYMENT_SEP: string = API_BASE_URL + 'api/client/makeTestPaymentSEP';



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/constants.ts